import { Wording } from '@/types';

export const LOVE_WORDING_RS: Wording = {
  components_header_media_content: 'Audio',
  components_header_media_1: 'Meditacije',
  components_header_media_2: 'Podkast',
  components_header_text1: 'Vodiči',
  components_header_text2: 'Blog',
  components_header_members: 'Članovi',
  hero_text: 'Otkrijte ljubav pomoću zvezda',
  hero_button_text: 'Počnite ovde',
  components_ressources_section_title: 'LJUBAV I ASTROLOGIJA',
  components_ressources_subheader_text: 'Nebeski Alat za Romantične Uvide',
  components_ressources_span_text: 'Zaronite u naš univerzum pokasta i članaka usredsređenih na ljubav, kompatibilnost zodijaka i kosmičku vezu. Bez obzira da li tražite jasnoću srodne duše ili dešifrujete svoje obrasce odnosa, naši resursi vas vode do dubljeg razumevanja kroz zvezde.',
  components_ressources_card_1_title: 'Zodijak Ljubavne Priče',
  components_ressources_card_1_text: 'Istražite iskrene epizode ​​podkasta udubljujući se u emocionalni jezik svakog znaka, ljubavnu kompatibilnost, strast i lični rast u odnosima.',
  components_ressources_card_2_title: 'Ljubavni Blog',
  components_ressources_card_2_text: 'Pročitajte uvide i razmišljanja o tome kako svaki znak voli, leči i povezuje se. Od sinastrije do planetarne romanse, naš blog je vaš vodič za astrološku ljubav.',
  components_ressources_link: 'Istraži dalje',
  components_notes_and_google_title_1: 'Romantična Astrologija',
  components_notes_and_google_title_2: 'Ljubavne Navike',
  components_notes_and_google_title_3: 'Iskustva slušalaca',
  components_review_google_text: 'Šta naši slušaoci kažu',
  media_content_section_title: 'LJUBAV I ZODIJAK PODKAST',
  media_content_section_subheader_text: 'Pravi razgovor o kosmičkoj romansi',
  text_media_1: 'Uključite se u duboke, otkrivajuće epizode ​​o astrološkim podudarnostima, emocionalnim obrascima i romantičnoj dinamici.',
  text_media_2: '',
  media_content_section_button_more: 'Slušaj sada',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Članci',
  text2_section_button_more: 'Učitaj više',
  components_text1_section_title: 'VODIČI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Dopustite zvezdama da predvode vašu ljubavnu priču',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registracioni broj',
  components_footer_legal: 'Pravni odeljak',
  components_footer_terms: 'Uslovi i odredbe',
  components_footer_privacy: 'Politika privatnosti',
  button_load_more: 'Učitaj još',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Ljubav i zodijak: Podkast Epizode',
  page_media_content_menu_compatibility: 'Kompatibilnost',
  page_media_content_menu_love: 'Ljubav',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Istražite ljubav kroz astrologiju',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Članci',
  enter_email_title: 'Unesite svoju e-mail adresu da biste nastavili',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Unesi',
  components_login_success_text: 'Prijava je uspela!',
  components_card_link_media_content: 'Slušaj sada',
  components_card_link_text2_content: 'Vidi vodič',
  components_card_link_text1_content: '',
  france: 'Francuska',
  cyprus: 'Kipar',
  tag_podcast: 'Подкаст',
  tag_meditation: 'Медитација',
  page_media_content_menu_all: 'Sve',
};